import { render, staticRenderFns } from "./MentionableInput.vue?vue&type=template&id=758514b2&scoped=true&"
import script from "./MentionableInput.vue?vue&type=script&lang=js&"
export * from "./MentionableInput.vue?vue&type=script&lang=js&"
import style0 from "./MentionableInput.vue?vue&type=style&index=0&id=758514b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758514b2",
  null
  
)

export default component.exports